<template>
  <v-container
    style="background-color: #21343b; position: relative"
    :class="$vuetify.breakpoint.width < 1264 ? 'px-7' : 'pl-12 pr-4'"
  >
    <v-row>
      <v-col style="color: white">
        <b>{{ $t('workspaceIcon') }}</b>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="2">
        <v-avatar
          :color="(!wsLogo || wsLogo === null ? currentWorkSpace.wsName : '') | iconBackground"
          class="logo"
          rounded
          size="50"
          @click="openDialog"
          style="cursor: pointer"
        >
          <span class="white--text text-h6 cent" v-if="!wsLogo || wsLogo === null">
            {{ currentWorkSpace.wsName | iconFilter }}
          </span>
          <v-img :src="wsLogo" v-else />
        </v-avatar>
      </v-col>
      <v-col align-self="center" v-if="isWsOwner">
        <el-button class="btn-delete-logo" :disabled="!wsLogo || wsLogo === null" @click="deleteWsLogo" type="gray">
          {{ $t('delete') }}
        </el-button>
        <el-button type="gray" class="logo">
          <label for="logo" style="color: white">{{ $t('upload') }}</label>
          <input accept=".png,.jpg,.jpeg" type="file" id="logo" @change="setWsLogo" />
        </el-button>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label for="fullName" class="text-left" style="color: white">
          <b>{{ $t('workspaceName') }}</b>
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-1 pb-0">
        <v-text-field
          type="text"
          solo
          dense
          dark
          ref="fullName"
          id="fullName"
          :readonly="!isWsOwner"
          :placeholder="$t('workspaceName')"
          hide-details="auto"
          @keyup="somethingChange"
          v-model="currentWorkSpace.wsName"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label for="displayName" class="text-left" style="color: white">
          <b>{{ $t('domainName') }}</b>
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-1 pb-0">
        <v-text-field
          prefix="www.tape.ooo/"
          solo
          dense
          dark
          ref="wsDomain"
          id="wsDomain"
          :readonly="!isWsOwner"
          placeholder="myworkspace"
          hide-details="auto"
          validate-on-blur
          v-model="currentWorkSpace.wsDomain"
          @keyup="replaceWsDomain()"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-10 mb-5" color="#E2E2E2" />

    <v-row v-if="isWsOwner">
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label class="text-left" style="color: white">
          <b>{{ $t('addMember') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button @click="openDialog('openAdd')" type="purple" style="width: 100px">{{ $t('add') }}</el-button>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label for="password" class="text-left" style="color: white">
          <b v-if="isWsOwner">{{ $t('manageMembers') }}</b>
          <b v-else>{{ $t('viewMembers') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button v-if="isWsOwner" @click="openDialog('openManage')" type="purple" style="width: 100px">
          {{ $t('manage') }}
        </el-button>
        <el-button v-else @click="openDialog('openManage')" type="purple" style="width: 100px">
          {{ $t('view') }}
        </el-button>
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-5" color="#E2E2E2" v-if="isWsOwner" />
    <v-row v-if="isWsOwner">
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label class="text-left" style="color: white">
          <b>{{ $t('deleteWorkspace') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button type="danger" @click="deleteWorkspace" style="width: 100px">{{ $t('delete') }}</el-button>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label class="text-left" style="color: white">
          <b>{{ $t('leaveWorkspace') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button type="danger" @click="leaveWorkspace" style="width: 100px">{{ $t('leave') }}</el-button>
      </v-col>
    </v-row>
    <v-row class="mt-10 mb-5 pr-3" justify="end">
      <v-btn class="btn-cancel" color="#777" dark @click="close">{{ $t('cancel') }}</v-btn>
      <v-btn
        class="ml-2"
        color="rgb(40, 144, 103)"
        dark
        :disabled="!isUpdate && !isLogoChanged"
        :loading="isLoading"
        @click="setWsUpdate"
        v-if="isWsOwner"
      >
        Update
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
// import common from '@/common/common'
import { setWsUpdate, setFileUpload, deleteWs, setInvalidCache, deleteWsLogo } from '@/services/api'
import { inputString } from '@/common/common'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters } from 'vuex'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'WorkspaceSetting',
  components: {},
  created() {
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '워크스페이스 설정',
        firebase_screen_class: 'WorkspaceSetting',
      },
    })
  },
  data() {
    return {
      currentWorkSpace: this.copyWsInfo(),
      storeWsInfo: this.$store.getters.selectedWsInfo,
      wsLogo: this.$store.getters.selectedWsInfo.wsLogo,
      isLogoChanged: false,
      wsName: null,
      wsDomain: null,
      wsMember: '',
      wsManager: '',
      isLoading: false,
      isUpdate: false,
    }
  },
  methods: {
    setWsLogo(e) {
      // TODO: 모달창으로 설정하도록 변경 필요
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
      e.target.value = ''
    },
    // TODO: common library로 이동
    createImage(file) {
      var reader = new FileReader()
      reader.onload = async (e) => {
        this.wsLogo = await this.resizeImage(e.target.result)
        this.isLogoChanged = true
      }
      reader.readAsDataURL(file)
    },
    // TODO: common library로 이동
    resizeImage(base64Str, maxWidth = 160, maxHeight = 160) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    async uploadLogo() {
      // wsLogo 업로드
      try {
        if (this.wsLogo !== null) {
          // wsLogo S3 업로드
          let parallellUploads = await setFileUpload(this, this.wsLogo, 'wsLogo', this.currentWorkSpace.wsId)
          parallellUploads.on('httpUploadProgress', () => {
            // ctx.progressValue = Math.floor(100 / (progress.total / progress.loaded))
          })
          // S3 Upload
          await parallellUploads.done()

          // Cloud Front 캐시 삭제
          await setInvalidCache(this, `/wsLogo/${this.currentWorkSpace.wsId}.png`)
        }
        // WsLogo 삭제
        else {
          try {
            await deleteWsLogo(this, this.currentWorkSpace.wsId)
          } catch (err) {
            this.error = err
          }
        }
      } catch (err) {
        this.error = err
      }
    },
    replaceWsDomain() {
      this.currentWorkSpace.wsDomain = this.currentWorkSpace.wsDomain.replace(/[^a-z0-9-]/gi, '')
      this.currentWorkSpace.wsDomain = this.currentWorkSpace.wsDomain.toLowerCase()

      this.somethingChange()
    },
    copyWsInfo() {
      let wsInfo = this.$store.getters.selectedWsInfo
      let info = {}
      if (wsInfo) {
        info = {
          wsId: wsInfo.wsId,
          wsName: wsInfo.wsName,
          wsDomain: wsInfo.wsDomain,
          wsLogo: wsInfo.wsLogo,
        }
      }
      return info
    },
    somethingChange() {
      this.isUpdate = !(
        this.currentWorkSpace.wsName === this.storeWsInfo.wsName &&
        this.currentWorkSpace.wsDomain === this.storeWsInfo.wsDomain
      )
      if (this.isUpdate) {
        if (this.currentWorkSpace.wsName !== this.storeWsInfo.wsName) {
          this.wsName = this.currentWorkSpace.wsName
        }

        if (this.currentWorkSpace.wsDomain !== this.storeWsInfo.wsDomain) {
          this.wsDomain = this.currentWorkSpace.wsDomain
        }
      }
    },
    deleteWsLogo() {
      this.wsLogo = null
      this.isLogoChanged = this.currentWorkSpace.wsLogo && this.currentWorkSpace.wsLogo !== null
    },
    async deleteWorkspace() {
      // 구독 정보가 남아있다면, 워크스페이스 삭제 불가 noti
      if (this.selectedWsInfo['stripeSubId'] && this.selectedWsInfo['stripeSubId'] !== '') {
        // notify(this, 'Error', this.$t('beforeDeleteChangePlanMsg'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('beforeDeleteChangePlanMsg'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } else {
        let app = this
        inputString(
          this,
          this.$t('deleteWorkspaceConfirmMsg'),
          this.$t('deleteWorkspace'),
          'text',
          app.currentWorkSpace.wsName,
          this.$t('msgWrongPassword'),
          (callback) => {
            if (callback.action === 'confirm') {
              if (callback.value === app.currentWorkSpace.wsName) {
                this.deleteWs()
              } else {
                // notify(app, 'Error', this.$t('inputStringErr'), 'error')
                const content = {
                  component: Toast,
                  props: {
                    msg: this.$t('inputStringErr'),
                    // submsg: '',
                  },
                }
                this.$toast.error(content)
              }
            }
          }
        )
      }
    },
    async deleteWs() {
      await this.$store.dispatch('setIsLoading', true)
      try {
        await deleteWs(this, 'WORKSPACE', this.currentWorkSpace.wsId, this.currentWorkSpace.wsDomain)
        // notify(this, 'Success', this.$t('joinWorkspaceComplete'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('joinWorkspaceComplete'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        localStorage.removeItem('lastSelectedWsInfo')
        this.$store.dispatch('setSelectedWsInfo', null)
      } catch (e) {
        // notify(this, 'Error', e.message, 'error')
        const content = {
          component: Toast,
          props: {
            msg: e.message,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
        location.reload()
      }
    },
    leaveWorkspace() {
      // 워크스페이스 소유자면 떠나기 불가 Noti
      if (this.isWsOwner) {
        // notify(this, 'Error', this.$t('notAvailableFeatureMsg'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('notAvailableFeatureMsg'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
      // 유료 가입자면 요금제 다운그레이드 후 나가도록 Noti
      else if (this.wsClipCnt['planType'] === 'Plus') {
        // notify(this, 'Error', this.$t('beforeLeaveChangePlanMsg'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('beforeLeaveChangePlanMsg'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
      // 워크스페이스 떠나기 팝업
      else {
        this.$emit('openDialog', 'Leave')
      }
    },
    openDialog(type) {
      this.$emit(type)
    },
    async setWsUpdate() {
      this.isLoading = true

      // Logo가 변경 되었으면 업로드를 진행해준다.
      if (this.isLogoChanged) await this.uploadLogo()

      // WsName || wsDomain 변경 시 호출해준다.
      if (this.isUpdate) {
        let params = {}
        if (this.wsName !== null && this.wsName !== this.storeWsInfo.wsName) params.wsName = this.wsName
        if (this.wsDomain !== null && this.wsDomain !== this.storeWsInfo.wsDomain) params.wsDomain = this.wsDomain
        try {
          let result = await setWsUpdate(
            this,
            this.currentWorkSpace.wsId,
            params
            // this.wsName !== null && this.wsName !== this.storeWsInfo.wsName ? this.wsName : undefined,
            // this.wsDomain !== null && this.wsDomain !== this.storeWsInfo.wsDomain ? this.wsDomain : undefined
          )
          this.$store.commit('setSelectedWsInfo', result)
          // if (this.wsDomain === null) {
          //   location.reload()
          // } else {
          //   location.href = `/${this.wsDomain}`
          // }
        } catch (err) {
          this.error = err
          console.log('error   ', err)
          // notify(this, 'Error', this.$t('msgWorkspaceDomainNotAvailable'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgWorkspaceDomainNotAvailable'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      }
      if ((this.isLogoChanged || this.isUpdate) && this.error === undefined) {
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        this.isLoading = false
        if (this.wsDomain === null) {
          location.reload()
        } else {
          location.href = `/${this.wsDomain}`
        }
      } else this.isLoading = false
    },
    close() {
      this.$emit('close', 'Setting')
    },
  },
  computed: {
    ...mapGetters(['isWsOwner', 'selectedWsInfo', 'wsClipCnt']),
    isMobile() {
      return isMobile()
      // return true
    },
  },
}
</script>

<style scoped>
.btn-delete-logo {
  color: #fff;
  background-color: #31434f;
  border-color: #31434f;
}
.el-button--gray {
  color: #fff;
  background-color: #31434f;
  border-color: #31434f;
}

.el-button--gray:hover {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--gray:active {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--gray:focus {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--purple {
  color: #fff;
  background-color: #6952dc;
  border-color: #6952dc;
}

.el-button--purple:hover {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.el-button--purple:active {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.el-button--purple:focus {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:hover {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:active {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:focus {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.setting-detail >>> .dis_primary {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.setting-detail >>> .dis_primary:hover {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.logo label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.logo label:hover {
  border-bottom: 1px solid #666;
}

.logo input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.logo img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}
</style>
